<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/internal-control')" style="cursor: pointer">Control Interno</li>
        <li class="breadcrumb-item active" aria-current="page">Integración de perfiles</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <vx-card>
        <h3>Integración de perfiles</h3>
      </vx-card>
      <div class="vx-row mt-5">
        <!-- CARD DE BUSQUEDA 1 -->
        <div class="vx-col w-1/2">
          <vx-card title="Búsqueda 1">
            <!-- PARAMETROS DE BUSQUEDA 1 -->
            <div class="vx-row">
                  <div class="vx-col w-full lg:w-1/3">
                      <vs-select
                      color="dark"
                      placeholder="Seleccione"
                      label="Opción de búsqueda"
                      class="w-full"
                      v-model.lazy="searchOption1Selected"
                      >
                          <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in searchOptions" />
                      </vs-select>
                  </div>
                  <div class="vx-col w-full lg:w-1/3">
                      <vs-input
                          color="dark"
                          class="w-full"
                          label="Ingrese"
                          v-model="inputSearch1"
                          v-on:keyup.enter="searchUserData(searchOption1Selected, inputSearch1, 1)"
                      />                    
                  </div>
                  <div class="vx-col w-full lg:w-1/3">
                      <vs-button :disabled="!inputSearch1 || !searchOption1Selected" @click="searchUserData(searchOption1Selected, inputSearch1, 1)" color="success" class="mt-6 btn-rgprimary">Consultar</vs-button>
                  </div>
            </div>
            <!-- RESPUESTA DE BUSQUEDA 1 -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <template v-if="resultDataResponse1">
                  <template v-if="lastSearchOption1Selected === 'PID'">
                    <user-profile-data title="CLIENTE" :userData="resultDataResponse1.client" @updated="dataUpdated"/>
                    <user-profile-data v-if="resultDataResponse1.supplier" title="PROVEEDOR" :userData="resultDataResponse1.supplier" @updated="dataUpdated"/>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                          <vs-divider color="dark">OBLIGADO SOLIDARIO</vs-divider>
                          <vs-list>
                              <vs-list-item title="CORREO">{{resultDataResponse1.guarantee.email}}</vs-list-item>
                          </vs-list>
                          <person-type-data :userData="resultDataResponse1.guarantee" @updated="dataUpdated"/>
                        </div>
                    </div>
                  </template>
                  <template v-else-if="lastSearchOption1Selected === 'CURP' || 'RFC'">
                    <div class="vx-row" v-if="!resultDataResponse1.user_id">
                        <div class="vx-col w-full">
                          <vs-divider color="dark">OBLIGADO SOLIDARIO</vs-divider>
                          <vs-list>
                              <vs-list-item title="CORREO">{{resultDataResponse1.guarantee.email}}</vs-list-item>
                              <vs-list-item title="PIDS"> {{ resultDataResponse1.guarantee.pids? resultDataResponse1.guarantee.pids:"Sin proyectos" }}</vs-list-item>
                          </vs-list>
                          <person-type-data :userData="resultDataResponse1.guarantee" @updated="dataUpdated"/>
                        </div>
                      </div>
                      <user-profile-data v-else title="USUARIO" :userData="resultDataResponse1" :showRoles="true" @updated="dataUpdated"/>
                  </template>
                  <template v-else>
                    <user-profile-data title="USUARIO" :userData="resultDataResponse1" :showRoles="true" @updated="dataUpdated"/>
                  </template>
                </template>
              </div>
            </div>
          </vx-card>
        </div>
        <!-- CARD DE BUSQUEDA 2 -->
        <div class="vx-col w-1/2">
          <vx-card title="Búsqueda 2">
            <!-- PARAMETROS DE BUSQUEDA 2 -->
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/3">
                  <vs-select
                  color="dark"
                  placeholder="Seleccione"
                  label="Opción de búsqueda"
                  class="w-full"
                  v-model.lazy="searchOption2Selected"
                  >
                      <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in searchOptions" />
                  </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                  <vs-input
                      color="dark"
                      class="w-full"
                      label="Ingrese"
                      v-model="inputSearch2"
                      v-on:keyup.enter="searchUserData(searchOption2Selected, inputSearch2, 2)"
                  />                    
              </div>
              <div class="vx-col w-full lg:w-1/3">
                  <vs-button :disabled="!inputSearch2 || !searchOption2Selected" @click="searchUserData(searchOption2Selected, inputSearch2, 2)" color="success" class="mt-6 btn-rgprimary">Consultar</vs-button>
              </div>
            </div>
            <!-- RESPUESTA DE BUSQUEDA 2 -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <template v-if="resultDataResponse2">
                  <template v-if="lastSearchOption2Selected === 'PID'">
                    <user-profile-data title="CLIENTE" :userData="resultDataResponse2.client" @updated="dataUpdated2"/>
                    <user-profile-data v-if="resultDataResponse2.supplier" title="PROVEEDOR" :userData="resultDataResponse2.supplier" @updated="dataUpdated2"/>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                          <vs-divider color="dark">OBLIGADO SOLIDARIO</vs-divider>
                          <vs-list>
                              <vs-list-item title="CORREO">{{resultDataResponse2.guarantee.email}}</vs-list-item>
                          </vs-list>
                          <person-type-data :userData="resultDataResponse2.guarantee" @updated="dataUpdated"/>
                        </div>
                    </div>
                  </template>
                  <template v-else-if="lastSearchOption2Selected === 'CURP' || 'RFC'">
                    <div class="vx-row" v-if="!resultDataResponse2.user_id">
                        <div class="vx-col w-full">
                          <vs-divider color="dark">OBLIGADO SOLIDARIO</vs-divider>
                          <vs-list>
                              <vs-list-item title="CORREO">{{resultDataResponse2.guarantee.email}}</vs-list-item>
                              <vs-list-item title="PIDS"> {{ resultDataResponse2.guarantee.pids? resultDataResponse2.guarantee.pids:"Sin proyectos" }}</vs-list-item>
                          </vs-list>
                          <person-type-data :userData="resultDataResponse2.guarantee" @updated="dataUpdated"/>
                        </div>
                      </div>
                      <user-profile-data v-else title="USUARIO" :userData="resultDataResponse2" :showRoles="true" @updated="dataUpdated2"/>
                  </template>
                  <template v-else>
                    <user-profile-data title="USUARIO" :userData="resultDataResponse2" :showRoles="true" @updated="dataUpdated2"/>
                  </template>
                </template>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import formatHelper from '@mixins/formatHelper';
import UserProfileData from './UserProfileData';
import PersonTypeData from './PersonTypeData';
export default  {
  name: 'users-profile-integration',
  mixins: [formatHelper],
  components: {UserProfileData, PersonTypeData},
  async mounted() {
  },
  data() {
    return {
      searchOptions: [
        'UID',
        'EMAIL',
        'RFC',
        'CURP',
        'PID',
        'IID',
        'CID',
        'SID',
        'PPID',
        'BPID'
      ],
      searchOption1Selected: "UID",
      searchOption2Selected: "UID",
      lastSearchOption1Selected: null,
      lastSearchOption2Selected: null,
      inputSearch1: null,
      inputSearch2: null,
      resultDataResponse1: null,
      resultDataResponse2: null
    }
  },
  methods: {
    async searchUserData(searchParam, searchInput, colSearchActive){
      this.showLoading(true);
      if (colSearchActive === 1) {
          this.resultDataResponse1 = null;
      }
      else{
          this.resultDataResponse2 = null;
      }
      await axios.post('/api/clients-control/users-profile-integration/search', {
          search_param: searchParam,
          search_input: searchInput,
      }).then(response => {
        if (colSearchActive === 1) {
          this.lastSearchOption1Selected = searchParam;
          this.resultDataResponse1 = response.data;
        }else{
          this.lastSearchOption2Selected = searchParam;
          this.resultDataResponse2 = response.data;
        }
        this.showLoading(false);
      }).catch(error => {
        if(error.response){
          this.errorNotifDialog("Aviso", error.response.data.message);
        }
        else {
          this.errorNotifDialog("Error", "Ha ocurrido un error en la aprobación");
        }
        this.showLoading(false);
      });
    },
    async dataUpdated() {
      await this.searchUserData(this.searchOption1Selected, this.inputSearch1, 1);
      this.successNotifDialog("Operación exitosa","Dato actualizado exitosamente");
    },
    async dataUpdated2() {
      await this.searchUserData(this.searchOption2Selected, this.inputSearch2, 2);
      this.successNotifDialog("Operación exitosa","Dato actualizado exitosamente");
    }
  }
}
</script>